import { components } from "@usher/pe-client-front-end-lib"
const MAX = 15
const DASHARRAY = 2 * Math.PI * 70
export const ProgressBar = ({ onUpdate }: { onUpdate: VoidFunction }) => {
  return (
    <components.Timer
      text="recalculated_in"
      format="ss"
      count_down={MAX}
      onUpdate={onUpdate}
      secText=""
      render={(text) => (
        <div className="flex items-center justify-center">
          <svg width="50" height="50" viewBox="0 0 160 160" style={{ transform: "rotate(-90deg)" }}>
            <circle
              r="70"
              cx="80"
              cy="80"
              fill="transparent"
              className="stroke-main-main"
              strokeWidth="12px"
              strokeDasharray={DASHARRAY}
              strokeDashoffset={(DASHARRAY * (Number(text) - MAX)) / MAX}
            ></circle>
          </svg>
          <div className="text-[18px] absolute text-black">{Number(text)}</div>
        </div>
      )}
    />
  )
}
